var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"capitalise"},[_vm._v(_vm._s(_vm.$t("ui.teamAttributes.selectYourTeam"))+":")]),_vm._l((_vm.possibleTeams.sort()),function(team){return _c('div',{key:team,staticClass:"team-select capitalise",on:{"click":function($event){return _vm.selectTeam(team)}}},[_vm._v(" "+_vm._s(team)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }